import { Filter } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum FilterActionTypes {
  SelectFilter = '[Filter] Select Filter',
  SearchDossiersByFilter = '[Filter] Search Dossiers By Filter',

  FetchFilterSearchCriteria = '[Filter] Fetch Filter Search Criteria',
  FetchFilterSearchCriteriaSuccess = '[Filter] Fetch Filter Search Criteria Success',
  FetchFilterSearchCriteriaFail = '[Filter] Fetch Filter Search Criteria Fail',

  ToggleFilterForm = '[Filter] Toggle Filter Form',

  ValidateFilterName = '[Filter] Validate Filter Name',
  ValidateFilterNameFail = '[Filter] Validate Filter Name Fail',

  CreateFilter = '[Filter] Create Filter',
  CreateFilterFail = '[Filter] Create Filter Fail',

  UpdateFilter = '[Filter] Update Filter',
  UpdateFilterFail = '[Filter] Update Filter Fail',

  ConfirmFilterRemoval = '[Filter] Confirm Filter Removal',
  DeleteFilter = '[Filter] Delete Filter',
  DeleteFilterSuccess = '[Filter] Delete Filter Success',
  DeleteFilterFail = '[Filter] Delete Filter Fail',
}

export class SelectFilter implements Action {
  readonly type = FilterActionTypes.SelectFilter;

  constructor(public payload: number) {
  }
}

export class SearchDossiersByFilter implements Action {
  readonly type = FilterActionTypes.SearchDossiersByFilter;
}

export class FetchFilterSearchCriteria implements Action {
  readonly type = FilterActionTypes.FetchFilterSearchCriteria;

  constructor(public payload: number) {
  }
}

export class FetchFilterSearchCriteriaSuccess implements Action {
  readonly type = FilterActionTypes.FetchFilterSearchCriteriaSuccess;

  constructor(public payload: Filter) {
  }
}

export class FetchFilterSearchCriteriaFail implements Action {
  readonly type = FilterActionTypes.FetchFilterSearchCriteriaFail;

  constructor(public payload: Error) {
  }
}

export class ToggleFilterForm implements Action {
  readonly type = FilterActionTypes.ToggleFilterForm;
}

export class ValidateFilterName implements Action {
  readonly type = FilterActionTypes.ValidateFilterName;

  constructor(public payload: { controlId: string; value: string }) {
  }
}

export class ValidateFilterNameFail implements Action {
  readonly type = FilterActionTypes.ValidateFilterNameFail;

  constructor(public payload: Error) {
  }
}

export class CreateFilter implements Action {
  readonly type = FilterActionTypes.CreateFilter;

  constructor(public payload: Filter) {
  }
}

export class CreateFilterFail implements Action {
  readonly type = FilterActionTypes.CreateFilterFail;

  constructor(public payload: Error) {
  }
}

export class UpdateFilter implements Action {
  readonly type = FilterActionTypes.UpdateFilter;

  constructor(public payload: Filter) {
  }
}

export class UpdateFilterFail implements Action {
  readonly type = FilterActionTypes.UpdateFilterFail;

  constructor(public payload: Error) {
  }
}

export class ConfirmFilterRemoval implements Action {
  readonly type = FilterActionTypes.ConfirmFilterRemoval;

  constructor(public payload: Filter) {
  }
}

export class DeleteFilter implements Action {
  readonly type = FilterActionTypes.DeleteFilter;

  constructor(public payload: number) {
  }
}

export class DeleteFilterSuccess implements Action {
  readonly type = FilterActionTypes.DeleteFilterSuccess;

  constructor(public payload: number) {
  }
}

export class DeleteFilterFail implements Action {
  readonly type = FilterActionTypes.DeleteFilterFail;

  constructor(public payload: Error) {
  }
}

export type FilterActions =
  | SelectFilter
  | SearchDossiersByFilter
  | FetchFilterSearchCriteria
  | FetchFilterSearchCriteriaSuccess
  | FetchFilterSearchCriteriaFail
  | ToggleFilterForm
  | ValidateFilterName
  | ValidateFilterNameFail
  | CreateFilter
  | CreateFilterFail
  | UpdateFilter
  | UpdateFilterFail
  | ConfirmFilterRemoval
  | DeleteFilter
  | DeleteFilterSuccess
  | DeleteFilterFail;
